import AdminGroups from './principals/groups/admin-groups'

import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'
import BaseRouter from 'scoreboard/components/base-router'
import Nav from './admin-nav'
import appDisplay from 'scoreboard/components/app-display'
import AdminApp from './configuration/admin-app'
import AdminServer from './configuration/admin-server'
import AdminLicenses from './licenses/admin-licenses'
import AdminLogs from './logs/admin-logs'
import AdminScoreboardDatabases from './connections/admin-impact-databases'
import AdminImportConnections from './connections/admin-import-connections'
import AdminDiagnostics from './diagnostics/admin-diagnostics'
import AdminRollupTrees from './datasets/admin-rollup-trees'
import CurrentUserActivity from './current-user-activity'
import BackgroundProcessStatus from './background-processes/background-processes'
import AdminCalendars from './calendars/admin-calendars'
import ScoringTypes from './scoring-types/scoring-types'
import SharedDashboards from './shared-dashboards/admin-shared-dashboards'
import ScheduledExports from './scheduled-exports/scheduled-exports'
import AlertPreferences from './alerts/alert-preferences'
import AdminUsers from './principals/users/admin-users'
import AccountInfo from './principals/users/account-info'
import user from 'scoreboard/components/user'
import globalDiagnostics from 'scoreboard/components/diagnostics'
import BroadcastAlert from './alerts/broadcast-alert'
import EmptyState from 'scoreboard/components/empty-state'
import noPermission from 'scoreboard/components/no-permission.hbs'
import permissions from 'scoreboard/components/permissions'
import databases from 'scoreboard/components/databases'
import SqlConsole from './sql-console'
import JsonStreamer from 'scoreboard/components/json-streamer'
import Imports from './imports/imports'
import valueImportStatus from './imports/import-status'
import SelectiveReplication from './configuration/selective-replication'
import projects from 'scoreboard/projects/projects'
import config from 'scoreboard/components/config'
import notFound from 'scoreboard/components/not-found.hbs'
import url from 'scoreboard/components/url'
import { BroadcastChannel } from 'broadcast-channel'
import MassEdit from './mass-edit/mass-edit'
import Backbone from 'backbone'
import ApiTokensView from './api-tokens/api-tokens-view'
import ApiTokens from './api-tokens/api-tokens'
import UserPermissionsAudit from './user-permissions-audit/user-permissions-audit'
import OrgPermissionsAudit from './org-permissions-audit/org-permissions-audit'
import DatasetPermissionsAudit from './dataset-permissions-audit'
import conductor from 'scoreboard/components/conductor'

var AdminRouter = BaseRouter.extend({

	routes: {
		'admin(/)': 'autoSelect',
		'admin/profile(/)': 'profile',
		'admin/alert-preferences(/)': 'alertPreferences',
		'admin/broadcast-alert(/)': 'broadcastAlert',
		'admin/app(/)': 'app',
		'admin/server(/)': 'server',
		'admin/scoreboard-databases(/)': 'scoreboardDatabases',
		'admin/import-connections(/)': 'importConnections',
		'admin/import-connections/:id(/)': 'importConnections',
		'admin/licenses(/)': 'licenses',
		'admin/users(/:id)(/)': 'users',
		'admin/groups/organizations(/:id)(/)': 'groupsByOrg', // must be first group route
		'admin/groups(/:id)(/)': 'groups',
		'admin/dataset-trees/:treeId/rollup-tree-groups(/:rollupTreeGroupId)(/)': 'rollupTreeGroup', // must be first tree route
		'admin/dataset-trees(/:id)(/)': 'datasetsTrees',
		'admin/shared-dashboards(/)': 'sharedDashboards',
		'admin/shared-forms(/)': 'sharedForms',
		'admin/scheduled-exports(/)': 'scheduledExports',
		'admin/calendars(/:id)(/)': 'calendars',
		'admin/scoring-types(/)': 'scoringTypes',
		'admin/diagnostics(/)': 'diagnostics',
		'admin/current-user-activity(/)': 'currentUserActivity',
		'admin/background-process-status(/)': 'backgroundProcessStatus',
		'admin/sql-console(/)': 'sqlConsole',
		'admin/logs(/)': 'logs',
		'admin/imports(/:id)(/:type)': 'imports',
		'admin/selective-replication(/)': 'selectiveReplication',
		'admin/third-party-connection(/)': 'thirdPartyConnection',
		'admin/mass-edit(/)': 'massEdit',
		'admin/user-permissions-audit(/:id)(/)': 'userPermissionsAudit',
		'admin/org-permissions-audit(/:id)(/)': 'orgPermissionsAudit',
		'admin/dataset-permissions-audit(/:id)(/)': 'datasetPermissionsAudit',
		'admin/api-tokens(/)': 'apiTokens',
	},

	Nav: Nav,
	section: 'admin',

	initialize: function() {
		BaseRouter.prototype.initialize.apply(this, arguments)
		this.listenTo(Backbone, 'mass-edit:filter', (filter) => {
			this.filter = filter
		})
	},

	/**
	 * #58309 In V6, the profile section was removed from the admin section, so
	 * it isn't clear, due to permissions, what the top admin section will be
	 * for a given user. This determines what that is and navigates to it.
	 */
	autoSelect: function() {
		this.withRenderedNav(nav => {
			const route = nav.$('.section-item:visible').eq(0).attr('href')
			conductor.navigate(route, { trigger: true })
		})
	},

	profile: function() {
		appDisplay.display(new AccountInfo({ model: user.model }))
		this.selectNav('profile')
	},

	alertPreferences: function() {
		appDisplay.display($.get({ url: 'api/alerts/subscriptions' }), function(data) {
			return new AlertPreferences({ data })
		})
		this.selectNav('alert-preferences')
	},

	broadcastAlert: function() {
		if (permissions.bookmarks()) {
			appDisplay.display(new BroadcastAlert())
			this.selectNav('broadcast-alert')
		} else {
			this.displayNoPermissions()
		}
	},

	app: function() {
		// #20029 either appAdmin or serverAdmin permission is required for Application Administration
		if (permissions.serverAdmin() || permissions.appAdmin()) {
			// openIdConnectionParameters must be sent over the wire as its own object,
			// but we just flatten out the properties for the form fields to KISS
			appDisplay.display($.get({ url: 'api/admin/app' }), (data) => {
				return new AdminApp({
					config: _.extend({}, data.config, data.openIdConnectionParameters),
					ldapServers: data.ldapServers,
					referToByLanguage: data.referToByLanguage,
					accountChangeAlertUsers: data.accountChangeAlertUsers,
					defaultAlertEmail: {
						name: data.defaultAlertEmailName,
						address: data.defaultAlertEmailAddress
					},
					globalTags: data.globalTags
				})
			})
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('app')
	},

	server: function() {
		if (permissions.serverAdmin()) {
			appDisplay.display($.get({ url: 'api/admin/server' }), function(config) {
				return new AdminServer({ config: config })
			})
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('server')
	},

	scoreboardDatabases: function() {
		if (permissions.serverAdmin()) {
			appDisplay.display($.get({ url: 'api/admin/databases' }), function(dbs) {
				databases.update(dbs)
				return new AdminScoreboardDatabases({ collection: dbs })
			})
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('scoreboard-databases')
	},

	importConnections: function(id) {
		// #22211 anyone can view import connections page
		appDisplay.display($.get({ url: 'api/admin/import-connections' }), function (connections) {
			// databases.update may be needed here.  not sure
			return new AdminImportConnections({
				selectedId: id,
				collection: connections
			})
		})

		this.selectNav('import-connections')
	},

	licenses: function() {
		if (permissions.serverAdmin()) {
			AdminLicenses.load()
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('licenses')
	},

	users: function(id) {
		if (permissions.modifyUsers() || permissions.deleteUsers()) {
			id = id === 'add' ? null : id
			appDisplay.display(new AdminUsers({ itemId: id }))
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('users')
	},

	groups: function(id, options = {}) {
		if (permissions.allGroups() || permissions.localAdmin()) {
			id = id === 'add' ? null : id
			appDisplay.display(new AdminGroups(_.extend({}, options, {
				itemId: id
			})))
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('groups')
	},

	groupsByOrg: function(orgId) {
		this.groups(undefined, {orgId, byOrg: true})
	},

	datasetsTrees: function(id) {
		this.rollupTreeGroup(id)
	},

	rollupTreeGroup: function(treeId, rollupTreeGroupId) {
		// #56866 require 'Administer Application' permission for navigating to
		// Admin | Dataset Rollup Trees or Rollup Tree Groups
		if (permissions.appAdmin()) {
			treeId = treeId === 'add' ? null : treeId
			let options = {
				itemId: treeId, rollupTreeGroupId
			}
			if (treeId) {
				let xhr = $.get({ url:'api/dataset-trees/' + treeId })
				appDisplay.display(xhr, metadata =>
					new AdminRollupTrees(_.extend(options, metadata)))
			} else {
				appDisplay.display(new AdminRollupTrees(options))
			}
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('datasets-trees')
	},

	sharedDashboards: function() {
		if (user.isStrictViewer()) {
			this.displayNoPermissions()
		} else {
			var url = 'api/dashboards/shared'
			var start = moment()
			const view = new SharedDashboards({start: start, section: 'dashboards'})
			JsonStreamer.initiate(view, { stream: 'sharedResources', url})
			appDisplay.display(view)
			this.selectNav('shared-dashboards')
		}
	},

	sharedForms: function() {
		if (user.isStrictViewer()) {
			this.displayNoPermissions()
		} else {
			var url = 'api/forms/shared'
			var start = moment()
			const view = new SharedDashboards({start: start, section: 'forms'})
			JsonStreamer.initiate(view, { stream: 'sharedResources', url})
			appDisplay.display(view)
			this.selectNav('shared-forms')
		}
	},

	scheduledExports: function() {
		var url = 'api/exports'
		var start = moment()
		const view = new ScheduledExports({start: start})
		JsonStreamer.initiate(view, { stream: 'exports', url})
		appDisplay.display(view)
		this.selectNav('scheduled-exports')
	},

	calendars: function(id) {
		if (permissions.calendars()) {
			appDisplay.display(new AdminCalendars({ calendarId: id }))
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('calendars')
	},

	scoringTypes: function() {
		// #48181 prevent navigating to  Admin | Scoring Types page for SMS
		if (config.sms) {
			appDisplay.display(new EmptyState({ body: notFound() }))
			return
		}
		if (permissions.appAdmin()) {
			appDisplay.display(new ScoringTypes())
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('scoring-types')
	},

	diagnostics: function() {
		if (permissions.serverAdmin()) {
			appDisplay.display($.get({ url: 'api/admin/diagnostics' }), function(diagnostics) {
				globalDiagnostics.readDiagnostics(diagnostics)
				return new AdminDiagnostics({ diagnostics: diagnostics })
			})
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('diagnostics')
	},

	currentUserActivity: function(id) {
		appDisplay.display($.get({ url: 'api/admin/users/active' }), function(users) {
			return new CurrentUserActivity({ users: users })
		})
		this.selectNav('current-user-activity')
	},

	backgroundProcessStatus: function() {
		appDisplay.display($.get({ url: 'api/admin/background-processes' }), function(bgProcesses) {
			return new BackgroundProcessStatus({ data: bgProcesses })
		})
		this.selectNav('background-process-status')
	},

	sqlConsole: function() {
		if (permissions.appAdmin() || permissions.readOnlySqlConsole()) {
			appDisplay.display(new SqlConsole({
				showQueryMetadata: true
			}))
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('sql-console')
	},

	selectiveReplication: function() {
		if (!config.replicationOutputEnabled) {
			appDisplay.display(new EmptyState({ body: notFound() }))
			return
		}

		if (permissions.appAdmin()) {
			let renderView = selections => {
				let projectId = projects.selectedOrFirstId()
				let view = new SelectiveReplication({selections, projectId})
				view.once('cancel', updatedSelections => {
					appDisplay.display(renderView(updatedSelections))
				})
				return view
			}
			appDisplay.display($.get({ url: 'api/admin/replication/selectedOrganizations' }), renderView)
		} else {
			this.displayNoPermissions()
		}

		this.selectNav('selective-replication')
	},

	displayNoPermissions: function() {
		appDisplay.display(new EmptyState({ body: noPermission() }))
	},

	logs: function() {
		appDisplay.display($.get({ url: 'api/admin/logs' }), function(logs) {
			return new AdminLogs({ logs: logs})
		})
		this.selectNav('logs')
	},

	imports: function(id, type) {
		// #29125 prevent view only users
		if (!permissions.readOnly()) {
			var importsPromise = $.get('api/imports', {
				owners: true,
				indirectOwners: true,
				connections: true
			})

			appDisplay.display(importsPromise, ({imports, datasets}) => {
				// Subscribe here because the import view unsubscribes in remove()
				// and that only happens inside of appDisplay.  If the user is already
				// in the imports section and clicks it again we need to not end up with
				// orphaned/old subscription channels (#32405)
				valueImportStatus.subscribe()
				return new Imports({
					collection: imports,
					datasets,
					id,
					type
				})
			})
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('imports')
	},

	/**
	 * redirect route for when an oauth login is complete and we're getting
	 * the Orb connectionId
	 */
	thirdPartyConnection: function() {
		const {connectionId, email} = url.getQueryParams()
		const bc = new BroadcastChannel('oauth-connections')
		bc.postMessage({connectionId, email}).then(() => {
			bc.close()
			window.close()
		})
	},

	massEdit: function() {
		// only allow "Mass Edit" for users with edit structure or
		// edit owner updaters (based on permissions from #14567)
		if (permissions.anyStructure() || permissions.anyOwnerUpdaters()) {
			// #43464 apply a starting filter if navigating from scorecards-edit
			let filter = this.filter
			appDisplay.display(new MassEdit({ filter }))
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('mass-edit')
	},

	orgPermissionsAudit: function(organizationId) {
		if (permissions.anyStructure()) {
			OrgPermissionsAudit.display(organizationId)
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('org-permissions-audit')
	},

	datasetPermissionsAudit: function(datasetId) {
		this.withRenderedNav(nav => {
			if (nav.modifySomeDatasetPermission) {
				DatasetPermissionsAudit.display(datasetId)
			} else {
				this.displayNoPermissions()
			}
			this.selectNav('dataset-permissions-audit')
		})
	},

	userPermissionsAudit: function(userId) {
		if (permissions.modifyUsers()) {
			UserPermissionsAudit.dialog(userId)
		} else {
			this.displayNoPermissions()
		}
		this.selectNav('user-permissions-audit')
	},

	apiTokens: function() {
		if (user.isStrictViewer()) {
			this.displayNoPermissions()
		} else {
			let xhr = $.get({ url: 'api/admin/api-tokens' })
			appDisplay.display(xhr, response =>
				new ApiTokensView({
					collection: new ApiTokens(response.tokens),
					users: response.users
				}))
		}
		this.selectNav('api-tokens')
	},

	selectNav(value) {
		this.withRenderedNav(nav => nav.select(value))
	},

	/**
	 * Executes the given callback once the nav pane finishs rendering
	 */
	withRenderedNav: function(callback) {
		this.nav().then(nav => {
			nav.onceRendered(() => callback(nav))
		})
	}

})

export default AdminRouter

AdminRouter.__filename__ = 'admin/admin-router.js'
